/**
 * Promedio ponderado de un conjunto de filas, normalizado por los pesos efectivamente
 * cargados: las filas sin valor o sin peso quedan fuera del promedio en vez de contarse
 * como cero. Devuelve null si ninguna fila aporta.
 */
function promedioPonderado(filas, peso, valor) {
  let sumaPesos = 0;
  let sumaValores = 0;

  filas.forEach((fila) => {
    const v = valor(fila);
    const p = Number(peso(fila) ?? 0);
    if (v === null || !Number.isFinite(p) || p <= 0) return;
    sumaPesos += p;
    sumaValores += v * p;
  });

  return sumaPesos > 0 ? sumaValores / sumaPesos : null;
}

/** Densidad de una fila de material, tomada de la fila o del material asociado. */
function densidadDe(fila) {
  const valor = Number(fila?.Densidad ?? fila?.Material?.Densidad ?? NaN);
  return Number.isFinite(valor) && valor > 0 ? valor : null;
}

/**
 * Estima la densidad del film resultante de un proceso de extrusión a partir de las resinas
 * cargadas: dentro de cada tornillo se pondera por el Porcentaje de cada material, y entre
 * tornillos por la Proporcion de cada uno.
 *
 * Se usa como fallback cuando el maestro de materiales no tiene cargada la densidad del
 * material resultante. Sin tornillos declarados, todas las resinas se tratan como una única
 * mezcla.
 *
 * @param {Array<{ItemTornillo:number, Proporcion:number}>} tornillos
 * @param {Array<{NumeroTornillo:number, Porcentaje:number, Densidad?:number, Material?:{Densidad?:number}}>} materiales
 * @returns {number|null} densidad en g/cm³ redondeada a 4 decimales, o null si no hay datos
 */
export function calcularDensidadResinas(tornillos, materiales) {
  const filasMateriales = Array.isArray(materiales) ? materiales : [];
  if (filasMateriales.length === 0) return null;

  const filasTornillos = Array.isArray(tornillos) ? tornillos : [];

  const densidad =
    filasTornillos.length === 0
      ? promedioPonderado(filasMateriales, (f) => f.Porcentaje, densidadDe)
      : promedioPonderado(
          filasTornillos,
          (t) => t.Proporcion,
          (t) => {
            const item = Number(t?.ItemTornillo ?? 0);
            const delTornillo = filasMateriales.filter(
              (m) => Number(m?.NumeroTornillo ?? 0) === item,
            );
            return promedioPonderado(delTornillo, (f) => f.Porcentaje, densidadDe);
          },
        );

  return densidad === null ? null : Number(densidad.toFixed(4));
}
